import { createContext } from "radix-vue";

export interface MenuContext {
  readonly isNested: boolean;
  readonly isMobile: boolean;
}

export const [inject, provide] = createContext<MenuContext>("Menu");
